import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'magnific-popup';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';

import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import PopupForPC from "./popup_select_component/PopupForPC";
import PopupForSP from "./popup_select_component/PopupForSP";
import ReactDOM from "react-dom";
import useSelectedItem from "./popup_select_component/SelectedItem";

import '../../../stylesheets/react_popup.scss';

const PopupSelect = props => {
  const [selectedIds, selectedSectionIds, setSelectedItemId, setItemIdsBySection] =
    useSelectedItem(props.selectedIds, props.itemTypes, props.isLimitedItem);
  const popupRef = useRef(); // for magnific-popup

  useEffect(() => {
    $.magnificPopup.open({
      items: {src: $(popupRef.current)},
      type: 'inline',
      fixedContentPos: true,
      callbacks: {
        close: () => {
          ReactDOM.unmountComponentAtNode(props.rootNode);
        }
      }
    }, 0);
  }, []);

  const onClickItem = itemId => setSelectedItemId(itemId);
  const onClickAllSelectBySectionUnit = sectionId => setItemIdsBySection(sectionId);
  const onClosePopup = () => {
    const selectedBusinessTypes = selectedIds.reduce((result, id) => {
        result.push({
          "id": id,
          "name": props.itemTypes.find(itemType => id === itemType.id).name
        });
        return result;
      }, []);
    props.onClosePopup(selectedBusinessTypes);
    $.magnificPopup.close();
    ReactDOM.unmountComponentAtNode(props.rootNode);
  };
  const onSubmit = () => {
    onClosePopup();
    props.onSubmit();
  };

  return (
    <div ref={popupRef} id="popup" className={props.popupOptions.iconClass + " select_popup"}>
      <PopupForSP
        popupOptions={props.popupOptions}
        recruitmentPrTypes={props.recruitmentPrTypes}
        sectionTypes={props.sectionTypes}
        selectedSectionIds={selectedSectionIds}
        itemTypes={props.itemTypes}
        isLimitedItem={props.isLimitedItem}
        selectedIds={selectedIds}
        onClickItem={onClickItem}
        onClosePopup={onClosePopup}
        onSubmit={onSubmit}
        ButtonArea={props.ButtonArea}
        onClickAllSelectBySectionUnit={onClickAllSelectBySectionUnit}
        needSelectedAllButton={props.needSelectedAllButton}
      />
      <PopupForPC
        popupOptions={props.popupOptions}
        recruitmentPrTypes={props.recruitmentPrTypes}
        sectionTypes={props.sectionTypes}
        itemTypes={props.itemTypes}
        isLimitedItem={props.isLimitedItem}
        selectedIds={selectedIds}
        onClickItem={onClickItem}
        onClosePopup={onClosePopup}
        onSubmit={onSubmit}
        ButtonArea={props.ButtonArea}
        onClickAllSelectBySectionUnit={onClickAllSelectBySectionUnit}
        needSelectedAllButton={props.needSelectedAllButton}
      />
    </div>
  )
};

PopupSelect.propTypes = {
  sectionTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      sort: PropTypes.number,
    }).isRequired
  ),
  itemTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      sort: PropTypes.number,
      sectionTypeId: PropTypes.number
    }).isRequired
  ),
  isLimitedItem: PropTypes.bool.isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.number),
  onClosePopup: PropTypes.func,
  onSubmit: PropTypes.func,
  ButtonArea: PropTypes.func.isRequired,
  needSelectedAllButton: PropTypes.bool,
  rootNode: PropTypes.object,
  popupOptions: PropTypes.object,
  recruitmentPrTypes: PropTypes.bool,
};

PopupSelect.defaultProps = {
  needSelectedAllButton: false,
  isLimitedItem: false,
};

export default PopupSelect;
